import { Navigate } from 'react-router-dom';
import { LoginForm } from '../components/LoginForm';
import { useAuth } from '../hooks/useAuth';

/**
 * POST /api/auth/login, with a form around it.
 *
 * The markup and the form state live in <LoginForm>, which the platform
 * console reuses. This page owns only what is specific to signing in to an
 * ORGANISATION: the session check, the call, and the redirect.
 */
export default function LoginPage() {
  const { login, isAuthenticated, isLoading } = useAuth();

  /*
   * Always land on "/" - the role signpost (Dashboard for admins, My Day
   * for everyone else). Restoring the pre-logout page confused people:
   * signing in fresh should start fresh. ProtectedRoute still stashes the
   * attempted URL in location.state.from; it is deliberately ignored.
   */
  const from = '/';

  // Wait for the initial /auth/me check before deciding anything, otherwise a
  // refresh on /login flashes the form at an already-signed-in user.
  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-slate-500">
        Loading...
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  return (
    <LoginForm
      title="ToDo Web Portal"
      subtitle="Sign in to continue to your tasks."
      footnote="Trouble signing in? Contact your administrator."
      /* The tenant API kept its historical wire name for the identifier,
         so a 422 arrives as body.username even though it holds an email. */
      identifierField="username"
      onSubmit={async (identifier, password) => {
        await login({ username: identifier, password });
        /*
         * No navigate() here on purpose: login() sets the user in
         * AuthContext, this component re-renders, and the isAuthenticated
         * guard above does the redirect.
         */
      }}
    />
  );
}
